import { AnimatePresence, motion } from 'motion/react'
import type { PropsWithChildren } from 'react'

export function QuestionTransition({
  id,
  direction,
  children,
}: PropsWithChildren<{ id: string; direction: 'forward' | 'backward' }>) {
  return (
    <AnimatePresence mode="wait" custom={direction}>
      <motion.div
        key={id}
        custom={direction}
        variants={{
          enter: (dir: 'forward' | 'backward') => ({ y: dir === 'forward' ? 60 : -60, opacity: 0 }),
          center: { y: 0, opacity: 1 },
          exit: (dir: 'forward' | 'backward') => ({ y: dir === 'forward' ? -60 : 60, opacity: 0 }),
        }}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
